<template>
  <div class="search-item" :style="{width:searchWidth}">
    <label class="search-label">{{searchLabel}}</label>
    <el-autocomplete  class="search-input" :readonly="false" v-model="value" :fetch-suggestions="queryCompany"
     @select="selectCompany" :trigger-on-focus="false" value-key="customerName" :placeholder="'请输入'+searchLabel"></el-autocomplete>
  </div>
</template>
<script>
	import contractJs from "@/assets/js/contract/contract.js";
  export default {
    name: "searchAutocomplete",
    props: {
      searchLabel: {
        type: String,
        default: ''
      },
      searchWidth: {
        type: String,
        default: ''
      },
      searchValue: {
        type: String,
        default: ''
      },
      searchTermList:{
        type: Array,
        default: []
      }
    },
    data: function() {
      return {
        value:this.searchValue,
      }
    },
    /* computed: {
    }, */
    methods: {
		selectCompany(item) {
		},
		queryCompany(queryString, cb) {
			contractJs.getByName(queryString).then((response) => {
				const data = response.data;
				if (data.code == 1) {
					cb(data.data);
				}
			}).catch((response) => {
				console.log(response)
			})
		},
    }
  };
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/list/search/searchAutocomplete.vue